export default {
    // 中
    zhCN: {
        organizational_affiliation: '所在组织',
        related_affiliations: '关联组织',
        vin_search: 'VIN查询',
        model_search: '车型查询',
        year: '年份',
        manual_type: '手册类型',
        manual_File: '手册文件',
    },
    // 英
    enUS: {
        organizational_affiliation: 'Organizational affiliation',
        related_affiliations: 'Related affiliations',
        vin_search: 'VIN Search',
        model_search: 'Model Search',
        year: 'Year',
        manual_type: 'Manual Type',
        manual_File: 'Manual File',
    },
    // 德
    deDE: {
        organizational_affiliation: 'Organisationszugehörigkeit',
        related_affiliations: 'Zugehörige Organisationen',
        vin_search: 'VIN-Suche',
        model_search: 'Modellsuche',
        year: 'Jahr',
        manual_type: 'Handbuch-Typ',
        manual_File: 'Handbuchdatei',
    },
    // 法
    frFR: {
        organizational_affiliation: 'Affiliation organisationnelle',
        related_affiliations: 'Organisations associées',
        vin_search: 'Recherche de VIN',
        model_search: 'Recherche de modèle',
        year: 'Année',
        manual_type: 'Type de manuel',
        manual_File: 'Fichier de manuel',
    },
    // 意大利
    itIT: {
        organizational_affiliation: 'Affiliazione organizzativa',
        related_affiliations: 'Affiliazioni correlate',
        vin_search: 'Ricerca VIN',
        model_search: 'Ricerca Modello',
        year: 'Anno',
        manual_type: 'Tipo di Manuale',
        manual_File: 'File del manuale',
    },
    // 荷兰
    nlNL: {
        organizational_affiliation: 'Organisatorische affiliatie',
        related_affiliations: 'Gerelateerde affiliaties',
        vin_search: 'VIN Zoeken',
        model_search: 'Model Zoeken',
        year: 'Jaar',
        manual_type: 'Handleidingstype',
        manual_File: 'Handleidingbestand',
    },
    // 越南
    viVN: {
        organizational_affiliation: 'Liên kết tổ chức',
        related_affiliations: 'Liên kết liên quan',
        vin_search: 'Tra Cứu VIN',
        model_search: 'Tra Cứu Mẫu Xe',
        year: 'Năm',
        manual_type: 'Loại Hướng Dẫn',
        manual_File: 'Tệp hướng dẫn',
    },
    // 西班牙
    esES: {
        organizational_affiliation: 'Afiliación organizacional',
        related_affiliations: 'Afiliaciones relacionadas',
        vin_search: 'Búsqueda de VIN',
        model_search: 'Búsqueda de Modelo',
        year: 'Año',
        manual_type: 'Tipo de Manual',
        manual_File: 'Archivo de manual ',
    },
    // 葡萄牙
    ptBR: {
        organizational_affiliation: 'Afiliação organizacional',
        related_affiliations: 'Afiliações relacionadas',
        vin_search: 'Pesquisa de VIN',
        model_search: 'Pesquisa de Modelo',
        year: 'Ano',
        manual_type: 'Tipo de Manual',
        manual_File: 'Arquivo do manual',
    },
    // 波兰
    plPL: {
        organizational_affiliation: 'Przynależność organizacyjna',
        related_affiliations: 'Powiązane organizacje',
        vin_search: 'Wyszukiwanie VIN',
        model_search: 'Wyszukiwanie modelu',
        year: 'Rok',
        manual_type: 'Typ Instrukcji',
        manual_File: 'Plik instrukcji',
    },
    // 土耳其
    trTR: {
        organizational_affiliation: 'Kurumsal üyelik',
        related_affiliations: 'İlgili kuruluşlar',
        vin_search: 'VIN Arama',
        model_search: 'Model Arama',
        year: 'Yıl',
        manual_type: 'Kullanım Kılavuzu Türü',
        manual_File: 'Kılavuz dosyası',
    },
    // 捷克语
    csCZ: {
        organizational_affiliation: 'Organizační příslušnost',
        related_affiliations: 'Související organizace',
        vin_search: 'Vyhledání VIN',
        model_search: 'Vyhledání modelu',
        year: 'Rok',
        manual_type: 'Typ Příručky',
        manual_File: 'Soubor příručky',
    },
    // 匈牙利语
    huHU: {
        organizational_affiliation: 'Szervezeti tagság',
        related_affiliations: 'Kapcsolódó szervezetek',
        vin_search: 'VIN Keresés',
        model_search: 'Modellkeresés',
        year: 'Év',
        manual_type: 'Kézikönyv Típusa',
        manual_File: 'Kézikönyv',
    },
    // 俄罗斯
    ruRU: {
        organizational_affiliation: 'Организационная принадлежность',
        related_affiliations: 'Связанные организации',
        vin_search: 'Поиск VIN',
        model_search: 'Поиск модели',
        year: 'Год',
        manual_type: 'Тип Руководства',
        manual_File: 'Руководство',
    },
};
